/**
 * Whole days a recording's video was kept before the retention sweep deleted
 * it — the truth about THIS row, rather than the org's current setting, which
 * may have changed since. Floored, so the hourly sweep's lag (a 3-day window
 * expires at 3 days + up to an hour) still reads "3 days".
 */
export function daysKeptBeforeExpiry(
    completedAt: string | undefined,
    expiredAt: string,
): number | null {
    if (!completedAt) return null;
    const completed = new Date(completedAt).getTime();
    const expired = new Date(expiredAt).getTime();
    if (Number.isNaN(completed) || Number.isNaN(expired) || expired < completed) {
        return null;
    }
    return Math.floor((expired - completed) / (24 * 60 * 60 * 1000));
}
